module.exports = __webpack_public_path__ + "img/limiteds.324ce224.png";